// extracted by mini-css-extract-plugin
module.exports = {"body":"body--3U3_K"};